import { Flex, RadioCards, Text } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { VisionCameraBoard } from 'lib_ts/enums/vision.enums';
import { Nullable } from 'lib_ts/interfaces/common/i-generics';
import { CSSProperties, FC, useMemo } from 'react';

const GRAPHIC_STYLE_CSS: CSSProperties = {
  height: '180px',
  marginBottom: 'var(--space-2)',
};

interface IProps {
  value: Nullable<VisionCameraBoard>;
  onChange: (v: VisionCameraBoard) => void;
  // e.g. manufacturing board should not be used for distance calibration
  excluded?: VisionCameraBoard[];
}

interface IBoardDef {
  value: VisionCameraBoard;
  imgSrc: string;
  name: string;
  description: string;
}

const BOARD_DEFS: IBoardDef[] = [
  {
    value: VisionCameraBoard.Manufacturing,
    imgSrc: '/img/renders/vcc-board-manufacturing.svg',
    name: 'Manufacturing Board',
    description: '12 x 9, 60mm squares',
  },
  {
    value: VisionCameraBoard.Field,
    imgSrc: '/img/renders/vcc-board-field.svg',
    name: 'Field Board',
    description: '7 x 8, 50mm squares',
  },
  {
    value: VisionCameraBoard.Rapsodo,
    imgSrc: '/img/renders/vcc-board-rapsodo.svg',
    name: 'Rapsodo Board',
    description: '5 x 8, 50mm squares',
  },
];

export const VisionCalibrationBoardSelector: FC<IProps> = (props) => {
  const validOptions = useMemo(
    () =>
      BOARD_DEFS.filter(
        (d) => !props.excluded || !props.excluded.includes(d.value)
      ),
    [props.excluded]
  );

  return (
    <ErrorBoundary identifier="VCBoardSelector">
      <RadioCards.Root
        columns={validOptions.length.toString()}
        value={props.value ?? ''}
        onValueChange={props.onChange}
      >
        {validOptions.map((d) => (
          <RadioCards.Item key={d.value} value={d.value}>
            <Flex direction="column" align="center" p="4">
              <img style={GRAPHIC_STYLE_CSS} src={d.imgSrc} />

              <Text size="2">{d.name}</Text>
              <Text size="2" color={RADIX.COLOR.SECONDARY}>
                {d.description}
              </Text>
            </Flex>
          </RadioCards.Item>
        ))}
      </RadioCards.Root>
    </ErrorBoundary>
  );
};
